import 'bootstrap-flat/css/bootstrap-flat.min.css';
import React from 'react';
import 'react-bootstrap-daterangepicker/css/daterangepicker.css';
import { injectIntl } from 'react-intl';
import 'react-select/dist/react-select.css';
import Adal from '../adal/adal-request';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './app.css';
import { browserHistory } from 'react-router';

require('es6-object-assign').polyfill();

class AppComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMsg: ''
    };

    console.log('NODE_ENV:', process.env.NODE_ENV); // Debug log
  }

  componentDidMount() {
    console.log('App component mounted');
    if (Adal.oauthData && Adal.oauthData.loginError) {
      this.setState({
        hasError: true,
        errorMsg: Adal.oauthData.loginError
      });
    } else {
       // after some secs force re-login
      this.timer = setTimeout(() => {
        console.log('Timer expired, forcing redirect...');
        Adal.forceRedirect();
      }, 5000);

      this.setState({
        hasError: false
      });

      this.props.actions.authUserAction().then(() => {
        console.log('User authenticated, fetching summary info...');
        this.props.actions.fetchSummaryInfo();

        console.log("Navigating to the main page...");
        browserHistory.push('/');

        if (this.timer) clearTimeout(this.timer);
      }, (error) => {
        console.error('Authentication failed:', error);
        this.setState({
          hasError: true,
          errorMsg: error.response
        });
        if (this.timer) {
          clearTimeout(this.timer);
        }
      });
    }

  }

  componentWillReceiveProps(nextProps) {
  }


  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({id: message}, data);
    };
    console.log('NODE_ENV:', process.env.NODE_ENV); // Debug log
    const { actions } = this.props;
    // SSO error
    if (this.state.hasError) {
      return (<div className="container">
        <div className="row" style={{textAlign: 'center', marginTop: '10px', marginBottom: '5px', marginLeft: '0px', marginRight: '0px'}}>
          <h3 style={{color: '#ff7300', fontWeight: 'bold'}}>{t('Authentication Error')}</h3>
          <p>
            {this.state.errorMsg}
          </p>
          <button type="button" className="btn btn-default  btn-brand" onClick={() => { Adal.logOut(); }}><span className="glyphicon glyphicon-log-out" /> &nbsp; {t('Log out')}</button>
                        &nbsp;
          <a href="/" className="btn btn-default  btn-brand"><span className="glyphicon glyphicon-home" /> Sign in again</a>
        </div>
      </div>);
    }
    // signing in waiting page
    if (!this.props.authInfo.authenticated) {
      return (<div className="row" style={{textAlign: 'center', marginTop: '10px', marginBottom: '5px', marginLeft: '0px', marginRight: '0px'}}>
        <h3 style={{color: '#ff7300', fontWeight: 'bold'}}>{t('WELCOME')} {t('APP_NAME')}</h3>
        <strong style={{color: '#ff7300'}}>PLEASE WAIT .... </strong>
        <br/>
        <br/>
        <br/>
        <br/>
        {false && <img src="/static/ripple.gif"/>}
      </div>);
    }
    // normal view
    return (
      <div className="row" style={{marginTop: '10px', marginBottom: '5px', marginLeft: '0px', marginRight: '0px'}}>
        <Header locale={this.props.locale} authInfo={this.props.authInfo} actions={actions}/>
        {this.props.children}
        <Footer/>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default injectIntl(AppComponent);



// WEBPACK FOOTER //
// ./components/App.js